import React, { useCallback, useState, useEffect } from "react";
import "./FriendlyUrlComponent.css";
import axiosConfig from "../../Service/axiosConfig";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import {
  ProductDetailPage,
} from "../../Pages";

import CategoriesPage from "../../Pages/CategoriesPage";
import SubCategoriesPage from "../../Pages/SubCategoriesPage";
import NotFound from "../../Pages/NotFound";

import { buildSeoPath } from "../../Utils/routes";

const FriendlyUrlComponent = () => {
  let { subcategoryurl, categoryurl, friendlyurl } = useParams();

  const location = useLocation();
  let navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [is404, setis404] = useState(false);

  const [ProductObject, setProductObject] = useState({
    product_type: "",
    product_data: null,
  });

  const GetData = useCallback(async () => {
    setLoading(true);
    setis404(false);

    try {
      const response = await axiosConfig.get(
        `/catlog/seo-url/${friendlyurl}/`
      );

      const { product_type, product_data } = response.data;

      setProductObject({
        product_type,
        product_data,
      });
    } catch (error) {
      console.log(error);
      setis404(true);
    } finally {
      setLoading(false);
    }
  }, [friendlyurl]);

  useEffect(() => {
    GetData();
  }, [GetData]);

  if (loading) {
    return (
      <div className="loader-container">
        <img
          src={require("../images/loader.gif")}
          alt="Loading..."
        />
      </div>
    );
  }

  if (is404) {
    return <NotFound />;
  }

  return (
    <div className="categories-container">

      {/* CATEGORY */}

      {ProductObject.product_type === "category" && (
        <>
          {/* <CategoriesPage
            category_id={ProductObject.product_data.id}
            category_slug={friendlyurl}
          /> */}
          <SubCategoriesPage
            category_id={ProductObject.product_data.id}
            category_slug={friendlyurl}
          />
          <Helmet>
            <title>{ProductObject.product_data.meta_title}</title>

            <meta
              property="og:title"
              content={ProductObject.product_data.meta_title}
            />

            <meta
              name="description"
              content={ProductObject.product_data.meta_description}
            />

            <meta
              property="keywords"
              content={ProductObject.product_data.meta_keyword}
            />
          </Helmet>
        </>
      )}
      {ProductObject.product_type === "subcategory" && (
        <>
          <SubCategoriesPage
            subcategory_id={ProductObject.product_data.id}
            category_id={
              ProductObject.product_data.category?.id ||
              ProductObject.product_data.category
            }
            category_slug={categoryurl}
            friendlyurl={friendlyurl}
            subcategoryName={ProductObject.product_data.name}
          />

          <Helmet>
            <title>{ProductObject.product_data.meta_title}</title>

            <meta
              property="og:title"
              content={ProductObject.product_data.meta_title}
            />

            <meta
              name="description"
              content={ProductObject.product_data.meta_description}
            />

            <meta
              property="keywords"
              content={ProductObject.product_data.meta_keyword}
            />
          </Helmet>
        </>
      )}
      {/* PROMOTIONAL CATEGORY */}

      {ProductObject.product_type === "promotionalcategory" && (
        <>
          <SubCategoriesPage
            promo_id={ProductObject.product_data.id}
            promotional_data={ProductObject.product_data}
            category_slug={categoryurl || friendlyurl}
            friendlyurl={friendlyurl}
          />

          <Helmet>
            <title>{ProductObject.product_data.meta_title}</title>

            <meta
              property="og:title"
              content={ProductObject.product_data.meta_title}
            />

            <meta
              name="description"
              content={ProductObject.product_data.meta_description}
            />

            <meta
              property="keywords"
              content={ProductObject.product_data.meta_keyword}
            />
          </Helmet>
        </>
      )}

      {/* PRODUCT */}

      {ProductObject.product_type === "product" && (
        <>
          <ProductDetailPage
            product_data={ProductObject.product_data}
            friendlyurl={friendlyurl}
            categoryurl={categoryurl}
            subcategoryurl={subcategoryurl}
          />

          <Helmet>
            <title>{ProductObject.product_data.meta_title}</title>

            <meta
              property="og:title"
              content={ProductObject.product_data.meta_title}
            />

            <meta
              name="description"
              content={ProductObject.product_data.meta_description}
            />

            <meta
              property="keywords"
              content={ProductObject.product_data.meta_keyword}
            />
          </Helmet>
        </>
      )}

      {/* CMS PAGE */}

      {ProductObject.product_type === "page" && (
        <div className="cms-page">
          <h1>{ProductObject.product_data.meta_title}</h1>

          <div
            dangerouslySetInnerHTML={{
              __html: ProductObject.product_data.description,
            }}
          />
        </div>
      )}
    </div>
  );
};

export { FriendlyUrlComponent };